import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { ToastrService } from 'ngx-toastr';
import { toggleLoading } from 'src/app/modules/redux';
import { UtilService } from 'src/app/modules/shared/services';
import { ModalSize } from 'src/app/modules/shared/services/util/util.service';
import { UuidService } from 'src/app/services';
import { DataService } from 'src/app/services/data/data.service';
import { IDealSyndication, IDealSubscription } from '../../models';
import { EntitiesForSubDocsModel, KycSignatoryForSubDocModel, SubDocsPersonModel } from '../../models/entities-for-subdoc';
import { IEntityDTO } from '../../models/syndication';
import { DealService, SubscriptionService, SyndicationService } from '../../services';
import { SubdocService } from '../../services/subdoc/subdoc.service';
import { DealSignatoryAddPersonModalComponent } from '../deal-signatory-add-person-modal/deal-signatory-add-person-modal.component';
import { first } from 'rxjs';

@Component({
  selector: 'app-deal-signers',
  templateUrl: './deal-signers.component.html',
  styleUrls: ['./deal-signers.component.scss']
})
export class DealSignersComponent implements OnInit {

  @Input() syndication!: IDealSyndication | IDealSubscription;

  allowChangesInSigners: boolean = false;
  businessUnitEntities: EntitiesForSubDocsModel[] = [];
  selectedBusinessUnitEntity?: EntitiesForSubDocsModel;
  selectedSignatory?: KycSignatoryForSubDocModel;
  dealSignatories: SubDocsPersonModel[] = [];

  constructor(private dealService: DealService,
    private subDocService: SubdocService,
    private store: Store,
    private toastrService: ToastrService,
    private util: UtilService,
    private dialog: MatDialog,
    private uuid: UuidService,
    private dataService: DataService,
    private router: Router,
    private subscriptionService: SubscriptionService,
    private syndicationService: SyndicationService
  ) { }

  ngOnInit(): void {
    console.log("Deal Issuer Signatories - syndication", this.syndication);

    this.syndicationService.getSyndication().pipe(first()).subscribe({
      next: (syndication: IDealSyndication) => {
        console.log("SYNDICATION", syndication);
        this.syndication = syndication;
        this.getEntitiesForBusinessUnit(this.syndication.issuerBusinessUnitId);
        this.getDealSignatories();
      }
    });

    


  }

  getErrorMsg() : string {
    return this.selectedBusinessUnitEntity?.kycErrorMessage ?? '';
  }

  getDisabledMsg() : string {
    if (this.syndication == null)
      return 'n/a';

    return this.syndication.numberOfIssuerSubDocSignatories == 1 ? 'Maximum of one (1) Signatory' : 'Maximum of two (2) Signatories';
  }

  addSelectedSignatory() {
    if (!this.selectedSignatory) {
      this.toastrService.error("Please select a signatory, or add a new one!");
      return;
    }

    if (this.dealSignatories.length >= 2) {
      this.toastrService.warning("You can have a minimum of 1 and maximum of 2 signers.");
      return;
    }

    this.dialog.open(DealSignatoryAddPersonModalComponent, {
      width: this.util.getModalWidth(ModalSize.SMALL),
      data: {
        fullName: this.selectedSignatory.name,
        email: ''
      }
    })
    .afterClosed().subscribe(result => {
      if (!!result) {
        this.dealSignatories.push(<SubDocsPersonModel> {
          id: this.uuid.generateFormattedUUID(),
          businessUnitEntityKycPersonId: this.selectedSignatory?.businessUnitEntityKycAuthorizedSignatoryId,
          fullName: result.fullName,
          email: result.email,
          sortOrder: this.dealSignatories.length + 1
        });
      }
    });
  }

  addNonKYCSignatory() {
    if (this.dealSignatories.length >= 2) {
      this.toastrService.warning("You can have a minimum of 1 and maximum of 2 signers.");
      return;
    }

    this.dialog.open(DealSignatoryAddPersonModalComponent, {
      width: this.util.getModalWidth(ModalSize.SMALL),
    })
    .afterClosed().subscribe(result => {
      if (!!result) {
        this.dealSignatories.push(<SubDocsPersonModel> {
          id: this.uuid.generateFormattedUUID(),
          businessUnitEntityKycPersonId: null,
          fullName: result.fullName,
          email: result.email,
          sortOrder: 1
        });
      }
    });
  }

  
  // ISSUER SIGNATORIES START
  removeSignatory(signatory: SubDocsPersonModel) {
    this.dealSignatories = this.dealSignatories.filter(x => x.id != signatory.id);
  }

  getEntitiesForBusinessUnit(businessUnitId: string) {
    // console.log("Fetching Entities...");
    this.subDocService.getSubdocEntities(businessUnitId).subscribe({
      next: (entities: IEntityDTO[]) => {
        console.log("Fetched Entities", entities);
        this.businessUnitEntities = entities;
      }, error: err => {
        this.toastrService.error("Unable to get entities!", $localize`:@@companyName:Rondeivu`);
      }
    });
  }

  getDealSignatories() {
    // console.log("Fetching Deal Signatories...");
    this.dealService.getDealSignatories().subscribe({
      next: (signatories: SubDocsPersonModel[]) => {
        console.log("Current Signatories", signatories)
        this.dealSignatories = Object.assign(signatories);
      }, error: err => {
        this.toastrService.error("Unable to get deal signatories!", $localize`:@@companyName:Rondeivu`);
      }
    });
  }

  saveDealSignatories() {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    var emailsNotValid = this.dealSignatories.filter(x => !x.email || !emailRegex.test(x.email));

    if (emailsNotValid.length > 0) {
      this.toastrService.warning("One of emails entered for signers is empty or invalid!");
      return;
    }

    if (this.dealSignatories.length > 2) {
      this.toastrService.warning("You can have a minimum of 1 and maximum of 2 signers.");
      return;
    }

    console.log("Updating Deal Signatories...");
    this.store.dispatch(toggleLoading({loading: true}));
    this.dealService.updateDealSignatories(this.dealSignatories).subscribe({
      next: (signatories: any) => {
        this.store.dispatch(toggleLoading({loading: false}));
        this.toastrService.success("Deal Signatories Updated!", $localize`:@@companyName:Rondeivu`);
        this.ngOnInit();
      }, error: err => {
        this.store.dispatch(toggleLoading({loading: false}));
        this.toastrService.error("Unable to update deal signatories!", $localize`:@@companyName:Rondeivu`);
      }
    });
  }

  openKyc() {
    if (!this.selectedBusinessUnitEntity) {
      this.toastrService.error("Could not resolve entity id");
      return;
    }

    var baseUrl = window.location.origin;
    var route = this.router.createUrlTree([this.dataService.getBuSlug(), 'entities', this.selectedBusinessUnitEntity.entityId, 'kyc', this.selectedBusinessUnitEntity.businessUnitEntityKycId]);
    var combinedUrl = baseUrl + route.toString();

    setTimeout(() => {
      window.open(combinedUrl, '_blank');
    }, 500);
  }

  get currentSignatoriesString() : string {
    if (this.dealSignatories.length > 0)
      return "Current Signatories " + this.dealSignatories.map(x => x.fullName).join(", ");
    else 
      return "No Signatories Set";
  }


}
